import  { useEffect, useState } from 'react';

import { useBoosters } from '@/features/boosters/model/useBoosters';
import { useIntroduceBoostersModalStore } from '@/features/boosters/model/useIntroduceBoostersModalStore';

import { isAnyModalOpen, subscribeToSettledModalClose } from '@/shared/lib/modal';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

const LS_KEY = 'hasShownBoostersPromo';

export const useBoostersPromo = () => {
  const { canPurchaseBoosters } = useBoosters()
  const openIntroduceBoostersModal = useIntroduceBoostersModalStore((state) => state.open);
  const [modalCloseCount, setModalCloseCount] = useState(0);

  useEffect(() => {
    if (!canPurchaseBoosters) return;

    const hasShown = localStorage.getItem(LS_KEY);
    if (hasShown) return;

    if (isAnyModalOpen()) return subscribeToSettledModalClose(() => setModalCloseCount((count) => count + 1));

    localStorage.setItem(LS_KEY, 'true');
    MixpanelEvents.generalModalBoostersBannerShown();
    openIntroduceBoostersModal();
  }, [openIntroduceBoostersModal, canPurchaseBoosters, modalCloseCount]);
};
